/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminUpdateGlobalSyncValueSchemaVersions} from '../api'

export const useMutationAdminUpdateGlobalSyncValueSchemaVersions = createReactQueryMutationHook('adminUpdateGlobalSyncValueSchemaVersions', adminUpdateGlobalSyncValueSchemaVersions)
